import makeAction from '../../../redux/utils/makeAction'
import { GoAction, PageSizeAction, SetAction } from '../types'

const go = makeAction<GoAction>('pagination/GO')
const pageSize = makeAction<PageSizeAction>('pagination/PAGE_SIZE')
const set = makeAction<SetAction>('pagination/SET')

export default { go, pageSize, set }
